export function formatIPCount(count: AvailableIPResult): string {
    if (count === 'invalid') {
        return 'Invalid';
    }

    const raw = count.toString();
    if (raw.length <= 6) {
        return Number(count).toLocaleString('pt-BR');
    } else {
        return '+100.000';
    }
}

type AvailableIPResult = number | bigint | 'invalid';

export function getAvailableIPCount (ipInput: string): AvailableIPResult {
    const [ip, maskStr] = ipInput.split('/');
    const isIPv6 = ip.includes(':');
    const maxBits = isIPv6 ? 128 : 32;

    // Parse and validate mask
    const mask = maskStr !== undefined ? parseInt(maskStr, 10) : maxBits;
    if (maskStr !== '' && (isNaN(mask) || mask < 0 || mask > maxBits)) {
        return 'invalid';
    }

    const hostBits = maxBits - mask;

    if (hostBits <= 0 || isNaN(hostBits)) {
        return 1;
    }

    const count = BigInt(2) ** BigInt(hostBits);
    return isIPv6 ? count : Number(count);
}

export function getFormattedAvailableIPCount (ip: string): string {
    return formatIPCount(getAvailableIPCount(ip));
}
